import React, { createContext, useContext, useState } from "react";
import {
  IRoomContext,
  IRoomData,
} from "../exports/interfaces";

const RoomContext = createContext<IRoomContext>({
  roomData: [],
  setRoomData: () => null,
});
export const useRoomContext = () => useContext(RoomContext);

export const RoomContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [roomData, setRoomData] = useState<IRoomData[]>([]);

  return (
    <RoomContext.Provider value={{ roomData, setRoomData }}>
      {children}
    </RoomContext.Provider>
  );
};
